/**
 * Galium Cargo — Scroll Animations
 * Uses IntersectionObserver for performant reveal animations.
 */

(function () {
  'use strict';

  const CLASSES = ['gc-reveal', 'gc-reveal-left', 'gc-reveal-right'];

  function initReveal() {
    const elements = document.querySelectorAll(CLASSES.map(c => '.' + c).join(','));
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach((el) => observer.observe(el));
  }

  // Typed headline animation for hero
  function initTypewriter() {
    const targets = document.querySelectorAll('[data-gc-typewriter]');
    targets.forEach((el) => {
      const text = el.textContent;
      el.textContent = '';
      el.style.borderRight = '2px solid currentColor';
      let i = 0;
      const interval = setInterval(() => {
        if (i < text.length) {
          el.textContent += text.charAt(i);
          i++;
        } else {
          clearInterval(interval);
          setTimeout(() => { el.style.borderRight = 'none'; }, 800);
        }
      }, 40);
    });
  }

  // Counter animation
  function initCounters() {
    const counters = document.querySelectorAll('[data-gc-counter]');
    if (!counters.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          const target = parseFloat(el.getAttribute('data-gc-counter'));
          const suffix = el.getAttribute('data-gc-counter-suffix') || '';
          const duration = 1800;
          const step = 16;
          const increment = target / (duration / step);
          let current = 0;

          const timer = setInterval(() => {
            current += increment;
            if (current >= target) {
              current = target;
              clearInterval(timer);
            }
            el.textContent = (Number.isInteger(target) ? Math.round(current) : current.toFixed(1)) + suffix;
          }, step);

          observer.unobserve(el);
        });
      },
      { threshold: 0.5 }
    );

    counters.forEach((el) => observer.observe(el));
  }

  // Parallax subtle effect on hero
  function initParallax() {
    const heroes = document.querySelectorAll('.gc-hero-parallax');
    if (!heroes.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;
      heroes.forEach((el) => {
        el.style.transform = `translateY(${scrollY * 0.25}px)`;
      });
    }, { passive: true });
  }

  function init() {
    initReveal();
    initCounters();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
